import { makeAutoObservable } from 'mobx'

import { Collection } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

class RecordWisePipelinesStore {
   private _recordWisePipelineIdsCollection: Collection<string, string[]>
   private _recordWiseNonPermittedFieldIds: Collection<string, string[]>

   private constructor() {
      this._recordWisePipelineIdsCollection = new Collection<string, string[]>(
         "the pipelines your are trying to access doesn't exist for record"
      )
      this._recordWiseNonPermittedFieldIds = new Collection<string, string[]>(
         "the record your are trying to access doesn't exist"
      )

      makeAutoObservable(this, {}, { autoBind: true })
   }

   hasRecordPipelineIds(recordId: string): boolean {
      const hasPipelines = this._recordWisePipelineIdsCollection.hasItem(
         recordId
      )

      return hasPipelines
   }

   setRecordPipelineIds(recordId: string, pipelineIds: string[]): void {
      this._recordWisePipelineIdsCollection.addItem(recordId, pipelineIds)
   }

   getRecordPipelineIds(recordId: string): string[] {
      return this._recordWisePipelineIdsCollection.getItem(recordId)
   }

   addNonPermittedFieldIdsForRecord = (
      recordId: string,
      fieldIds: string[]
   ): void => {
      this._recordWiseNonPermittedFieldIds.addItem(recordId, fieldIds)
   }

   getIsNonPermittedFieldForRecord = (recordId: string, fieldId: string) => {
      const recordNonPermittedFields = this._recordWiseNonPermittedFieldIds.getItem(
         recordId
      )
      return recordNonPermittedFields.includes(fieldId)
   }

   static create(): RecordWisePipelinesStore {
      return new RecordWisePipelinesStore()
   }
}

export default RecordWisePipelinesStore
